var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page"},[_c('div',{staticClass:"container text-center",staticStyle:{"font-size":"26px","line-height":"36px","padding":"40px 0"}},[_c('br'),_c('Br'),_vm._v(" "),_c('h2',{staticClass:"pageHeader"},[_vm._v("404 - brak takiej strony")])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0a8d17ae","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/PageNotFound.vue
// module id = null
// module chunks = 